import { LILAC_200, LILAC_500, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getFilterDesktopStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    header: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: spacing.SPACING_20
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: spacing.SPACING_8,
      paddingHorizontal: spacing.SPACING_20
    },
    marginTopStyle: {
      marginTop: spacing.SPACING_20
    },
    paddingBottomStyle: {
      paddingBottom: spacing.SPACING_8
    },
    itemContainer: {
      marginVertical: spacing.SPACING_12,
      paddingHorizontal: spacing.SPACING_20
    },
    dividerStyle: {
      marginBottom: spacing.SPACING_20,
      borderBottomColor: LILAC_500
    },
    cardStyle: {
      maxWidth: 420,
      backgroundColor: LILAC_200
    },
    contentStyle: {}
  });
};